"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
require("dayjs/locale/ms-my");
var Calendar = {
    formatYear: 'YYYY',
    formatMonth: 'MMM YYYY',
    monthBeforeYear: true,
    today: 'hari ini',
    view: {
        month: 'bulan',
        year: 'tahun',
        week: 'minggu',
        day: 'hari',
    },
    month: {
        long: {
            January: 'Januari',
            February: 'Februari',
            March: 'Mac',
            April: 'April',
            May: 'Mei',
            June: 'Jun',
            July: 'Julai',
            August: 'Ogos',
            September: 'September',
            October: 'Oktober',
            November: 'November',
            December: 'Disember',
        },
        short: {
            January: 'Jan',
            February: 'Feb',
            March: 'Mac',
            April: 'Apr',
            May: 'Mei',
            June: 'Jun',
            July: 'Jul',
            August: 'Ogos',
            September: 'Sept',
            October: 'Okt',
            November: 'Nov',
            December: 'Dis',
        },
    },
    week: {
        long: {
            self: 'Minggu',
            monday: 'Isnin',
            tuesday: 'Selasa',
            wednesday: 'Rabu',
            thursday: 'Khamis',
            friday: 'Jumaat',
            saturday: 'Sabtu',
            sunday: 'Ahad',
        },
        short: {
            self: 'Minggu',
            monday: 'Isn',
            tuesday: 'Sel',
            wednesday: 'Rab',
            thursday: 'Kha',
            friday: 'Jum',
            saturday: 'Sab',
            sunday: 'Ahd',
        },
    },
};
exports.default = {
    locale: 'ms-MY',
    dayjsLocale: 'ms-my',
    Calendar: Calendar,
    DatePicker: {
        Calendar: Calendar,
        placeholder: {
            date: 'Sila pilih tarikh',
            week: 'Sila pilih seminggu',
            month: 'Sila pilih bulan',
            year: 'Sila pilih tahun',
            quarter: 'Sila pilih suku',
        },
        placeholders: {
            date: ['tarikh mula', 'tarikh tamat'],
            week: ['minggu mula', 'hujung minggu'],
            month: ['bulan permulaan', 'akhir bulan'],
            year: ['tahun mula', 'akhir tahun'],
            quarter: ['suku mula', 'akhir suku tahun'],
        },
        selectTime: 'tempoh pemilihan',
        selectDate: 'pilih tarikh',
        today: 'hari ini',
        now: 'sekarang',
        ok: 'okey',
    },
    Drawer: {
        okText: 'okey',
        cancelText: 'batalkan',
    },
    Empty: {
        noData: 'Tiada data',
    },
    Modal: {
        okText: 'okey',
        cancelText: 'batalkan',
    },
    Pagination: {
        goto: 'pergi ke',
        page: 'Halaman',
        countPerPage: 'Artikel / Halaman',
        total: 'Jumlah {0}',
        prev: 'halaman sebelumnya',
        next: 'muka surat seterusnya',
        currentPage: 'halaman {0}',
        prevSomePages: 'Maju ke hadapan {0} halaman',
        nextSomePages: '{0} halaman belakang',
        pageSize: 'mukasurat',
    },
    Popconfirm: {
        okText: 'okey',
        cancelText: 'batalkan',
    },
    Table: {
        okText: 'okey',
        resetText: 'set semula',
        sortAscend: 'Klik dalam susunan menaik',
        sortDescend: 'Klik dalam susunan menurun',
        cancelSort: 'unsort',
    },
    TimePicker: {
        ok: 'okey',
        placeholder: 'Sila pilih masa',
        placeholders: ['Masa mula', 'Masa tamat'],
        now: 'sekarang',
    },
    Progress: {
        success: 'Selesai',
        error: 'gagal',
    },
    Upload: {
        start: 'mulakan',
        cancel: 'batalkan',
        delete: 'padam',
        reupload: 'Klik untuk mencuba lagi',
        upload: 'Klik untuk memuat naik',
        preview: 'pratonton',
        drag: 'Klik atau seret fail untuk memuat naik di sini',
        dragHover: 'Kosongkan fail dan mula memuat naik',
        error: 'muatnaik gagal',
    },
    Typography: {
        copy: 'salinan',
        copied: 'disalin',
        edit: 'edit',
        fold: 'lipat',
        unfold: 'mengembang',
    },
    Transfer: {
        resetText: 'set semula',
    },
    ImagePreview: {
        fullScreen: 'skrin penuh',
        rotateRight: 'putar ke kanan',
        rotateLeft: 'berputar ke kiri',
        zoomIn: 'besarkan',
        zoomOut: 'zum keluar',
        originalSize: 'saiz asal',
    },
};
